export const generateSource = (source, video_id) => {
  switch (source) {
    case 'youtube':
      return `https://www.youtube.com/embed/${video_id}?rel=0`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${video_id}`;
    default:
      return false;
  }
};
